module.exports = __webpack_public_path__ + "media/application/images/svgs/icon_email-2139201bcc844f35807d6178a991db0e.svg";